import { h, FunctionComponent } from 'preact'
import { useContext, useState } from 'preact/hooks'
import cls from 'classnames'

import { CsatField as CsatFieldType } from 'scripts/type'
import FieldsContext from '../fieldsContext'
import FieldWrapper from '../components/FieldWrapper'

import styles from './csat.scss'

import img1 from './images/1.png'
import img2 from './images/2.png'
import img3 from './images/3.png'
import img4 from './images/4.png'
import img5 from './images/5.png'
import img1off from './images/1-off.png'
import img2off from './images/2-off.png'
import img3off from './images/3-off.png'
import img4off from './images/4-off.png'
import img5off from './images/5-off.png'
import { FieldCommonProps } from '../type'
import { useHandlersWithRequired } from '../hooks'
import usePropValueChange from 'components/business/SurveyForm/Fields/hooks/usePropValueChange'
import BaseContext from 'contexts/base-context'
import { WidgetWidth } from 'components/business/Preview/type'

const csatImages = [img1, img2, img3, img4, img5]
const csatUnselectedImages = [img1off, img2off, img3off, img4off, img5off]

const CELL_WIDTH = {
  [WidgetWidth.SMALL]: 56,
  [WidgetWidth.NORMAL]: 64,
  [WidgetWidth.LARGE]: 64,
  [WidgetWidth.XLARGE]: 64,
}

const IMAGE_SIZE = {
  [WidgetWidth.SMALL]: 28,
  [WidgetWidth.NORMAL]: 36,
  [WidgetWidth.LARGE]: 36,
  [WidgetWidth.XLARGE]: 36,
}

const TEXT_SIZE = {
  [WidgetWidth.SMALL]: 11,
  [WidgetWidth.NORMAL]: 13,
  [WidgetWidth.LARGE]: 13,
  [WidgetWidth.XLARGE]: 13,
}

const CsatField: FunctionComponent<FieldCommonProps> = (props) => {
  const { field, required, onFieldSubmit } = props
  const { isMultipleFields } = useContext(FieldsContext)!
  const { width } = useContext(BaseContext)!
  const [, setValue] = useState<number | null>(null)
  const { ratingDescriptions } = field as CsatFieldType
  const [hoverIndex, setHoverIndex] = useState<null | number>(null)
  const [selectedIndex, setSelectedIndex] = useState<null | number>(null)
  const { onClickHandler, onNext } = useHandlersWithRequired(setValue, required, onFieldSubmit)
  const hasItemSelected = (selectedIndex ?? -1) > -1
  usePropValueChange(props, () => {
    setValue(null)
    setSelectedIndex(null)
    setHoverIndex(null)
  })

  const onClick = (value: number, index: number) => {
    if (!isMultipleFields && hasItemSelected) {
      return
    }
    setValue(value)
    setSelectedIndex(index)
    onClickHandler()
  }

  const containerClasses = cls(styles.csatField, {
    [styles.required]: required,
    'pointer-events-none': !isMultipleFields && hasItemSelected,
  })

  return (
    <FieldWrapper {...props} handlerProps={{ visible: !required, onNext }}>
      <div className={containerClasses}>
        {ratingDescriptions.map((item, index) => {
          const highlight = typeof hoverIndex === 'number' && hoverIndex === index
          const selected = selectedIndex === index
          const isUnselected = !selected && !highlight

          return (
            <div
              key={index}
              className={cls(styles.item, {
                [styles.selected]: highlight || selected,
                pulse: selected,
              })}
              onMouseEnter={() => setHoverIndex(index)}
              onMouseLeave={() => setHoverIndex(null)}
            >
              <a
                onClick={() => onClick(index + 1, index)}
                className={styles.score}
                style={{ width: CELL_WIDTH[width] }}
              >
                <img
                  src={isUnselected ? csatUnselectedImages[index] : csatImages[index]}
                  width={IMAGE_SIZE[width]}
                  height={IMAGE_SIZE[width]}
                  alt={item}
                />
              </a>
              <div className={styles.text} style={{ fontSize: TEXT_SIZE[width] }}>
                {item}
              </div>
            </div>
          )
        })}
      </div>
    </FieldWrapper>
  )
}

export default CsatField
